import { render, staticRenderFns } from "./ApprovePublishMeeting.vue?vue&type=template&id=6ada9e59&"
import script from "./ApprovePublishMeeting.vue?vue&type=script&lang=js&"
export * from "./ApprovePublishMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports